export function escapeHtmlSpecialChars(content: string): string {
  // Escape HTML special characters in order to embed into a raw HTML string
  // Does not check for already escaped HTML
  return content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

export interface SafeHtmlObject {
  changingThisBreaksApplicationSecurity: string
}

/** Determine if the object is a SafeHtml style object. */
export function isSafeHtmlObject(content: unknown): content is SafeHtmlObject {
  return (
    content instanceof Object &&
    'changingThisBreaksApplicationSecurity' in content &&
    typeof (content as SafeHtmlObject).changingThisBreaksApplicationSecurity ===
      'string'
  )
}
